import React from 'react';
import { Messages, Control, API, Code, Name, Title, Actions, Form, Hooks, Files, Toast, Button, useListContext, useCallback, useEffect, useState, Utility } from 'helpers/ListImports';
import { Credit } from 'models/CreditModel';


const CreditList: React.FC = () => {
  const width = { client: 30, amount: 10, date: 12, user: 24, refno: 18 }
  const [formId, formName] = [Code.Form.Id.CREDIT, Code.Form.Name.CREDIT];
  const { loading, setLoading, error, setError, search, setSearch, pno, setPno, pageRows, setPageRow, activeId, setActiveId, selected, setSelected, confirm, setConfirm, message, setMessage,  showMenu, setShowMenu, selectedItems, setSelectedItems, selectAllChecked, setSelectAllChecked, activeOptions, setActiveOptions, rowOptions, setRowOptions, menuPosition, setMenuPosition, iframeRef, filterRef, contextMenuRef  } = useListContext();
  const [creditData, setCreditData] = useState<Credit[]>([]); 
  const [selectedCredit, setselectedCredit] = useState<Credit | null>(null);
  const triggers = [pno, pageRows, search, activeId];
  const Privilege = Hooks.Privilege.List(formId);
  const PrivClient = Hooks.Privilege.List(Code.Form.Id.CLIENT);
  
  Hooks.Privilege.HasView(Privilege);
  
  Form.Click.Outside([contextMenuRef, filterRef],[() => setShowMenu(false),() => {}],true);
  Form.Select.OnChange(selectedItems, setSelected);

  useEffect(() => {
    Files.Json.Http(Code.File.ACTIVE, Code.Option.Common.NOTHING, setActiveOptions, setError);
    Files.Json.Http(Code.File.ROW, Code.Option.Common.NOTHING, setRowOptions, setError);
  }, []);

  useEffect(() => {
    callListData(); 
  }, triggers);
 
  const callListData = useCallback(async () => {
    const url = API.Build.ListApiEndpoint(formName, pno, pageRows, Name.Credit.Id, Code.Option.Sort.DESC, activeId, search, {
      fields: Utility.Join.Fields([
        Name.Credit.Id, 
        Name.Client.FullName, 
        Name.Credit.Date, 
        Name.Credit.Amount, 
        Name.Credit.RefNo, 
        Name.User.FullName
      ]),
    });
     
    await API.Data.List<Credit>(url, setCreditData, setError, setLoading); 
  }, triggers);

  

  return (
    <Control.List.Frame>
      <Control.List.Panel>
        <Control.List.Tools>
          <Control.Tool.Left>
            <Button.Create title={formName} onClick={() => Form.Show.Popup(iframeRef, formName)} Privilege={Privilege} />
            {selected && ( <Button.Delete onClick={()=>Toast.Delete.MultipleRecords(activeId, selectedItems, setConfirm)} activeId={activeId} Privilege={Privilege} /> )}
          </Control.Tool.Left>
          <Control.Tool.Right>
            <Control.SearchBar onSearch={setSearch} onFilterToggle={() => Form.Show.Filter(filterRef)}  onGoClick={() => callListData()} />
            <Control.List.Filter filterRef={filterRef}>
              <Control.Dropdown title={Title.State} value={activeId} options={activeOptions} onChange={setActiveId} />
              <Control.Dropdown title={Title.Rows} value={pageRows} options={rowOptions} onChange={setPageRow} />
            </Control.List.Filter>
            <Messages.Confirm Messages={confirm} onConfirm={() => API.Data.MultiDelete(formName, activeId, callListData, selectedItems, setConfirm, setMessage, setSelected, setSelectedItems, setError) } onRefuse={() => setSelectedItems([])} />
          </Control.Tool.Right>
        </Control.List.Tools>
        <Control.List.Data>
          <Control.List.Box>
            <Control.List.Title>
              <Control.SelectAll selectAllChecked={selectAllChecked} onSelectAll={(e) => Form.Select.All(e, setSelectedItems, creditData, setSelectAllChecked,formName)} extra={1} />
              <Control.Grid.Items values={[
                [Title.ClientName, width.client], 
                [Title.Amount, width.amount, Code.Align.RIGHT], 
                [Title.Date, width.date],
                [Title.User, width.user],
                [Title.Refno, width.refno],
              ]} last={1} upper={true} />
            </Control.List.Title>
            {!loading && !error && Array.isArray(creditData) && (
              <Control.Grid.Row>
                {creditData.map((creditData) => { return (
                <Control.Grid.Data<Credit> key={creditData.credit_id} itemKey={creditData.credit_key} data={creditData} setMenuPosition={setMenuPosition} setSelectedData={setselectedCredit} setShowMenu={setShowMenu} >
                  <Control.Grid.Check keyId={creditData.credit_key} selectedItems={selectedItems} toggleSelection={Form.Select.Toggle} setSelectedItems={setSelectedItems} />
                  <Control.Grid.Modify path={Utility.Join.Edit(Privilege, formName, creditData.credit_key)} iframeRef={iframeRef} Privilege={Privilege} />
                  <Control.Grid.Link value={Utility.Get.FullName(creditData,Code.Form.Name.CLIENT)} path={Utility.Join.Edit(PrivClient, Code.Form.Name.CLIENT, creditData.client_id)} width={width.client} iframeRef={iframeRef} /> 
                  <Control.Grid.Items values={[
                    [Utility.Format.Amount(creditData.credit_amount), width.amount, Code.Align.RIGHT],
                    [Utility.Format.DateOnly(creditData.credit_date), width.date],
                    [Utility.Get.FullName(creditData,Code.Form.Name.USER), width.user],
                    [creditData.credit_ref_number, width.refno],
                  ]} />
                  <Control.Grid.Actions>
                    <Control.Action.All formName={formName} activeId={activeId} keyId={creditData.credit_key} iframeRef={iframeRef} setSelectedItems={setSelectedItems} setConfirm={setConfirm} Privilege={Privilege}><></></Control.Action.All>
                  </Control.Grid.Actions>
                </Control.Grid.Data>)})}
            </Control.Grid.Row>)}
          </Control.List.Box>
        </Control.List.Data>
        <Control.List.Info>
          <Control.RecordInfo pageNo={pno} pageRows={pageRows} loading={loading} error={error} dataLength={creditData.length} />
          <Control.Pagination pageNo={pno} onChange={(page) => setPno(page)} />
        </Control.List.Info>
      </Control.List.Panel>
      {showMenu && (<div ref={contextMenuRef}><Control.ListContextMenu showMenu={showMenu} formName={formName} onCreate={() => Form.Show.Popup(iframeRef, formName)} onModify={()=>Form.Show.Popup(iframeRef, Utility.Join.Edit(Privilege, formName,selectedCredit?.credit_key))} onDelete={() => Toast.Delete.SingleRecord(activeId, selectedCredit?.credit_key, setSelectedItems, setConfirm)} onClose={() => Form.Parent.TabClose()} setShowMenu={setShowMenu} Privilege={Privilege} pos={menuPosition} /></div>)}
      <Control.FormPopup iframeRef={iframeRef} onRefresh={callListData} />
      <Actions.List />
    </Control.List.Frame>
  );
};

export default CreditList;